import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktProjectContainerModel } from '../../../../../../models/aggregates/dgmkt/dgmkt-project/dgmkt-project-container.model';
import { Pagination, ApiVisa } from '../../shared';

@Injectable({
  providedIn: 'root',
})
export class DgMktProjectService extends BaseApiTemplateService<DgMktProjectContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'projects';

  constructor(http: HttpClient) {
    super();

    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'projects';

    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'projects';

    this.httpClient = http;
  }

  async exportProjectCampaignsReportCsvAsBlob(
    pagination: Pagination,
    apiVisa: ApiVisa
  ) {
    let { apiUrl } = this;

    if (this.endpoint_path && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }

    const CSV_URL =
      apiUrl +
      '/reports/project-campaigns/export/csv?' +
      pagination.getQueryKeyValues();

    const headers = new HttpHeaders({
      authorization: apiVisa.jwt_secret,
      tenantCode: apiVisa.tenantCode,
    });

    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();

    return fileBlob;
  }
}
